import React from "react";

import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import Stack, { StackProps } from "@readai/pulse/components/Stack";

export const TimeSlotHeader = styled(Typography)({
  fontSize: "0.875rem",
  fontWeight: 600,
  alignSelf: "flex-start",
});

type TimeSlotListProps = StackProps & { width?: React.CSSProperties["width"] };

export const TimeSlotList = styled<React.FC<TimeSlotListProps>>(
  ({ width: _w, ...props }) => <Stack spacing={1} {...props} />,
)(({ width }) => ({
  width: width ?? "250px",
  maxWidth: "100%",
}));

type TimeSlotPanelProps = StackProps & { show: boolean };

const TimeSlotPanelWithRef = React.forwardRef<
  HTMLDivElement,
  TimeSlotPanelProps
>(({ show: _s, ...props }, ref) => <Stack {...props} ref={ref} />);
TimeSlotPanelWithRef.displayName = "TimeSlotPanelWithRef";

export const TimeSlotPanel = styled(TimeSlotPanelWithRef)(
  ({ show, theme }) => ({
    paddingTop: theme.spacing(1),
    flexGrow: show ? 1 : 0,
    [theme.breakpoints.up("lg")]: {
      flexBasis: show ? "50%" : "0%",
    },
  }),
);

export const BestTimesBanner = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.shades.ghost[300],
  padding: theme.spacing(1),
  borderRadius: "4px",
  color: theme.palette.shades.neutral[800],
  margin: theme.spacing(1, 2, 0),
}));
